import { create } from 'zustand';
import { authAPI } from '../apis/auth';

type State = unknown;

type Action = {
  checkTenureExpired: (params: {
    uid: string;
  }) => Promise<{ success: true; redirectUrl?: string } | { success: false; errorMessage: string; error: unknown }>;
};

type TenureCheckStore = State & Action;

export const useTenureCheckStore = create<TenureCheckStore>()(() => ({
  checkTenureExpired: async ({ uid }) => {
    try {
      const data = await authAPI.checkTenureStatus({ uid });
      const tenureExpired = data.tenureExpired ?? 'N';

      if (tenureExpired === 'Y') {
        return {
          success: true,
          redirectUrl: `/ciam-tenure-check${window.location.search}`,
        };
      }

      return { success: true };
    } catch (error) {
      const err = error as { response: { data: { message: string } } };
      if (err.response.data.message === 'lastTenureCheck not found') {
        return {
          success: true,
          redirectUrl: `/ciam-tenure-check${window.location.search}`,
        };
      }

      return {
        success: false,
        errorMessage: 'Failed to check tenure expired',
        error,
      };
    }
  },
}));
